<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import { useToast } from '@/composables/useToast'

const { error } = useToast()

const handleApiError = (event: CustomEvent<{ message: string }>) => {
  error(event.detail.message)
}

onMounted(() => {
  window.addEventListener('api-error', handleApiError as EventListener)
})

onUnmounted(() => {
  window.removeEventListener('api-error', handleApiError as EventListener)
})
</script>

<template>
  <Toast />
  <RouterView />
</template>

<style scoped>
</style>
